<template>
  <ReadOnlyItem v-if="disabled" :gray="gray" :label="title" :value="vModel" />
  <IonItem
    v-else
    class="inline-input-item"
    :color="gray ? 'whitesmoke' : 'white'"
    lines="full"
    :id="`inlineInput-${title}`"
  >
    <div slot="start" class="flex items-center h-[60px] truncate">
      <ValidationIcon :valid-icon-color="iconColor" :valid-icon="icon" :state="state" :errors="errors"></ValidationIcon>
      <div class="font-medium text-gray-500">{{ title }}</div>
    </div>
    <div class="flex items-center h-[60px] w-full ml-auto">
      <input
        type="text"
        :value="vModel"
        @input="onInput"
        :disabled="disabled"
        class="appearance-none text-right w-full bg-transparent outline-none placeholder:text-gray-500 placeholder:font-medium font-medium disabled:text-gray-500"
        :class="{ 'text-gray-700': !textColor || textColor === 'default', 'text-blue-500': textColor === 'blue' }"
        :placeholder="placeholder || `Enter ${title}`"
      />
      <IconButton
        v-if="vModel && clearable && !disabled"
        class="ml-2"
        size="small"
        icon="icon-x"
        @click="onClearClicked($event)"
        color="medium"
      ></IconButton>
    </div>
  </IonItem>
</template>

<script setup lang="ts">
import { IonItem } from '@ionic/vue';
import IconButton from '../IconButton.vue';
import { FormControlError, FormControlState } from '@/composables/use-form-control';
import ValidationIcon from '../ValidationIcon.vue';
import ReadOnlyItem from '../ReadOnlyItem.vue';
withDefaults(
  defineProps<{
    title: string;
    placeholder?: string;
    gray?: boolean;
    clearable?: boolean;
    icon?: string;
    state?: FormControlState;
    errors?: FormControlError[];
    textColor?: 'default' | 'blue';
    disabled?: boolean;
    iconColor?: 'gray' | 'blue';
  }>(),
  { clearable: true }
);

const vModel = defineModel({ type: String });

function onInput(ev: any) {
  vModel.value = ev.target.value;
}

function onClearClicked(ev: MouseEvent) {
  ev.stopPropagation();
  ev.preventDefault();
  vModel.value = undefined;
}
</script>

<style scoped>
ion-item.inline-input-item::part(native) {
  --border-width: 1px;
}

ion-item.inline-input-item {
  --padding-start: 0px;
}
</style>
